import React, { Component } from 'react';
import {Link} from 'react-router-dom';

import HttpRunner from '../query';
import EntityIdQuery from '../entityIdQuery';
import urlHandler from '../../../utils/urlHandler';
import miscUtils from '../../../utils/miscUtils';

class DocKbAttributes extends Component {
    constructor(props){
        super(props);
    }

    render() {
        return (
            <div className="bucket" id="top">
                <h3 className="heading-1">Knowledgebase Entity Fields</h3>
                <div className="description">
                    The following table documents the entity fields available from the Finch Entity Knowledgebases. This data 
                    is returned from the entity lookup service:
                    <code className="api-definition">
                            <span className="get-badge">GET</span>&nbsp;{urlHandler.API_ENDPOINT_V2_ENTITIES}/{'{'}entity_id{'}'}
                    </code>
                </div>
                <br/>
                <div className="example-content host">
                    NOTE: The fields marked as (<span className="fa fa-star normalized" style={{paddingLeft: '5px'}}></span>) are normalized and included in the proximity context vector of 
                    the entity to improve disambiguation performance.<br/>
                </div>

                <table className="table-wrapper">
                    <thead className="table-header">
                    <tr>
                        <th>Element Path </th>
                        <th>GEO </th>
                        <th>PERSON </th>
                        <th>ORGANIZATION </th>
                        <th>THING </th>
                        <th>Notes </th>
                    </tr>
                    </thead>
                    <tbody className="table-body">
                    <tr>
                        <td className="attribute">id</td>
                        <td className="type"><span className="fa fa-check"></span></td>
                        <td className="type"><span className="fa fa-check"></span></td>
                        <td className="type"><span className="fa fa-check"></span></td>
                        <td className="type"><span className="fa fa-check"></span></td>
                        <td className="notes">The entities globally unique identifier. Mandatory element.</td>
                    </tr>
                    <tr>
                        <td className="attribute">type</td>
                        <td className="type"><span className="fa fa-check"></span></td>
                        <td className="type"><span className="fa fa-check"></span></td>
                        <td className="type"><span className="fa fa-check"></span></td>
                        <td className="type"><span className="fa fa-check"></span></td>
                        <td className="notes">The type of entity. One of GEO, PERSON, ORGANIZATION or THING. Mandatory element.</td>
                    </tr>
                    <tr>
                        <td className="attribute">label <span className="fa fa-star normalized"></span> <span className="fa fa-search entity-search"></span></td>
                        <td className="type"><span className="fa fa-check"></span></td>
                        <td className="type"><span className="fa fa-check"></span></td>
                        <td className="type"><span className="fa fa-check"></span></td>
                        <td className="type"><span className="fa fa-check"></span></td>
                        <td className="notes">A finch canonical name for the entity. Omit if not available.</td>
                    </tr>
                    <tr>
                        <td className="attribute">version</td>
                        <td className="type"></td>
                        <td className="type"><span className="fa fa-check"></span></td>
                        <td className="type"><span className="fa fa-check"></span></td>
                        <td className="type"><span className="fa fa-check"></span></td>
                        <td className="notes">The version of the published knowledgebase.<br/>
                            <br/>
                            Specified in format &lt;major&gt;.&lt;minor&gt;.&lt;patch&gt;.&lt;MJD&gt;<br/>
                            <br/>
                            The MJD (modified Julian date) will only show for entities from customer knowledgebases.
                        </td>
                    </tr>
                    <tr>
                        <td className="attribute">description <span className="fa fa-search entity-search"></span></td>
                        <td className="type"></td>
                        <td className="type"><span className="fa fa-check"></span></td>
                        <td className="type"><span className="fa fa-check"></span></td>
                        <td className="type"><span className="fa fa-check"></span></td>
                        <td className="notes">A short description for the entity. Omit if not available.</td>
                    </tr>
                    <tr>
                        <td className="attribute">prominence</td>
                        <td className="type"></td>
                        <td className="type"><span className="fa fa-check"></span></td>
                        <td className="type"><span className="fa fa-check"></span></td>
                        <td className="type"><span className="fa fa-check"></span></td>
                        <td className="notes">The derived proprietary prominence score based on wiki linking. Omit if not available.</td>
                    </tr>
                    <tr>
                        <td className="attribute">contextKeywords <span className="fa fa-star normalized"></span></td>
                        <td className="type"></td>
                        <td className="type"><span className="fa fa-check"></span></td>
                        <td className="type"><span className="fa fa-check"></span></td>
                        <td className="type"><span className="fa fa-check"></span></td>
                        <td className="notes">An array of relevent keywords to the entity.</td>
                    </tr>
                    <tr>
                        <td className="attribute">userData</td>
                        <td className="type"></td>
                        <td className="type"><span className="fa fa-check"></span></td>
                        <td className="type"><span className="fa fa-check"></span></td>
                        <td className="type"><span className="fa fa-check"></span></td>
                        <td className="notes">A string representation of a JSON object containing user-defined attributes. The 
                            JSON object may contain nested objects and arrays, but must be valid JSON syntax.
                        </td>
                    </tr>
                    <tr>
                        <td className="attribute">document</td>
                        <td className="type"></td>
                        <td className="type"><span className="fa fa-check"></span></td>
                        <td className="type"><span className="fa fa-check"></span></td>
                        <td className="type"><span className="fa fa-check"></span></td>
                        <td className="notes">The document text.<br/>
                            <br/>
                            User edited entities only.
                        </td>
                    </tr>
                    <tr>
                        <td className="attribute">nameVariations[] <span className="fa fa-star normalized"></span> <span className="fa fa-search entity-search"></span></td>
                        <td className="type"></td>
                        <td className="type"><span className="fa fa-check"></span></td>
                        <td className="type"><span className="fa fa-check"></span></td>
                        <td className="type"><span className="fa fa-check"></span></td>
                        <td className="notes">A string array used to create "normalized" names that the 
                            disambiguation engine uses to identify matching entities in the knowledge base.<br/>
                            <br/>
                            Normalization differs from entity to entity, however, it is important that all common 
                            variations of a name are listed. E.g. IBM should include IBM, International Business 
                            Machines, International Business Machines Corporation, IBM Corporation. In some cases, former 
                            names for the company or for companies that have been merged into the company and no longer 
                            exist as a separate entity should be included. E.g. Compaq and Compaq Computer Company 
                            could be included as name variations for Hewlett Packard.
                        </td>
                    </tr>
                    <tr>
                        <td className="attribute">twitterNames[] <span className="fa fa-star normalized"></span> <span className="fa fa-search entity-search"></span></td>
                        <td className="type"></td>
                        <td className="type"><span className="fa fa-check"></span></td>
                        <td className="type"><span className="fa fa-check"></span></td>
                        <td className="type"><span className="fa fa-check"></span></td>
                        <td className="notes">An array of Twitter usernames associated with the entity.</td>
                    </tr>
                    <tr>
                        <td className="attribute">facebookIds[] <span className="fa fa-star normalized"></span> <span className="fa fa-search entity-search"></span></td>
                        <td className="type"></td>
                        <td className="type"><span className="fa fa-check"></span></td>
                        <td className="type"><span className="fa fa-check"></span></td>
                        <td className="type"><span className="fa fa-check"></span></td>
                        <td className="notes">An array of Facebook ids associated with the entity.</td>
                    </tr>
                    <tr>
                        <td className="attribute">permIds[] <span className="fa fa-search entity-search"></span></td>
                        <td className="type"></td>
                        <td className="type"><span className="fa fa-check"></span></td>
                        <td className="type"><span className="fa fa-check"></span></td>
                        <td className="type"></td>
                        <td className="notes">An array of ID’s linking to Thomson Reuters Open PermID. 
                            See: {miscUtils.createExternalLink('https://permid.org/')}
                        </td>
                    </tr>
                    <tr>
                        <td className="attribute">ciks[] <span className="fa fa-search entity-search"></span></td>
                        <td className="type"></td>
                        <td className="type"><span className="fa fa-check"></span></td>
                        <td className="type"><span className="fa fa-check"></span></td>
                        <td className="type"></td>
                        <td className="notes">An array of Central Index Key (CIK) numbers assigned to individuals or 
                            companies by the US Securities and Exchange Commission who have filed disclosure 
                            with the SEC. 
                            See: {miscUtils.createExternalLink('https://www.sec.gov/edgar/searchedgar/cik.htm')}
                        </td>
                    </tr>
                    <tr>
                        <td className="attribute">languageFields[]</td>
                        <td className="type"></td>
                        <td className="type"><span className="fa fa-check"></span></td>
                        <td className="type"><span className="fa fa-check"></span></td>
                        <td className="type"><span className="fa fa-check"></span></td>
                        <td className="notes">An array of language-specific objects. Omit if not available.
                        </td>
                    </tr>
                    <tr>
                        <td className="attribute">languageFields[].urls[]</td>
                        <td className="type"></td>
                        <td className="type"><span className="fa fa-check"></span></td>
                        <td className="type"><span className="fa fa-check"></span></td>
                        <td className="type"><span className="fa fa-check"></span></td>
                        <td className="notes">An array of urls specific to the current language object. Omit if not available.
                        </td>
                    </tr>
                    <tr>
                        <td className="attribute">languageFields[].langCode</td>
                        <td className="type"></td>
                        <td className="type"><span className="fa fa-check"></span></td>
                        <td className="type"><span className="fa fa-check"></span></td>
                        <td className="type"><span className="fa fa-check"></span></td>
                        <td className="notes">A two digit ISO 639-1 code that identifies the language for the current language object. 
                            See: {miscUtils.createExternalLink('https://en.wikipedia.org/wiki/List_of_ISO_639-1_codes','ISO 639-1')}.
                        </td>
                    </tr>
                    <tr>
                        <td className="attribute">languageFields[].description</td>
                        <td className="type"></td>
                        <td className="type"><span className="fa fa-check"></span></td>
                        <td className="type"><span className="fa fa-check"></span></td>
                        <td className="type"><span className="fa fa-check"></span></td>
                        <td className="notes">The entity description in the language of the current language object. Omit if not available.
                        </td>
                    </tr>
                    <tr>
                        <td className="attribute">languageFields[].label</td>
                        <td className="type"></td>
                        <td className="type"><span className="fa fa-check"></span></td>
                        <td className="type"><span className="fa fa-check"></span></td>
                        <td className="type"><span className="fa fa-check"></span></td>
                        <td className="notes">The entity label in the language of the current language object. Omit if not available.
                        </td>
                    </tr>
                    <tr>
                        <td className="attribute">identifiers[]</td>
                        <td className="type"></td>
                        <td className="type"><span className="fa fa-check"></span></td>
                        <td className="type"><span className="fa fa-check"></span></td>
                        <td className="type"><span className="fa fa-check"></span></td>
                        <td className="notes">An array of objects that represent an identifier.</td>
                    </tr>
                    <tr>
                        <td className="attribute">identifiers[].type</td>
                        <td className="type"></td>
                        <td className="type"><span className="fa fa-check"></span></td>
                        <td className="type"><span className="fa fa-check"></span></td>
                        <td className="type"><span className="fa fa-check"></span></td>
                        <td className="notes">The type of identifier.</td>
                    </tr>
                    <tr>
                        <td className="attribute">identifiers[].value</td>
                        <td className="type"></td>
                        <td className="type"><span className="fa fa-check"></span></td>
                        <td className="type"><span className="fa fa-check"></span></td>
                        <td className="type"><span className="fa fa-check"></span></td>
                        <td className="notes">The identifier value.</td>
                    </tr>
                    <tr>
                        <td className="attribute">identifiers[].primary</td>
                        <td className="type"></td>
                        <td className="type"><span className="fa fa-check"></span></td>
                        <td className="type"><span className="fa fa-check"></span></td>
                        <td className="type"><span className="fa fa-check"></span></td>
                        <td className="notes">Boolean value that represents a primary identifier. Default true.</td>
                    </tr>
                    <tr>
                        <td className="attribute">identifiers[].current</td>
                        <td className="type"></td>
                        <td className="type"><span className="fa fa-check"></span></td>
                        <td className="type"><span className="fa fa-check"></span></td>
                        <td className="type"><span className="fa fa-check"></span></td>
                        <td className="notes">Boolean value that represents a currently used identifier. Default true.</td>
                    </tr>
                    <tr>
                        <td className="attribute">identifiers[].startDate</td>
                        <td className="type"></td>
                        <td className="type"><span className="fa fa-check"></span></td>
                        <td className="type"><span className="fa fa-check"></span></td>
                        <td className="type"><span className="fa fa-check"></span></td>
                        <td className="notes">A string formatted as an ISO-8601 date that represents the start of usage. Omit if not available.</td>
                    </tr>
                    <tr>
                        <td className="attribute">identifiers[].endDate</td>
                        <td className="type"></td>
                        <td className="type"><span className="fa fa-check"></span></td>
                        <td className="type"><span className="fa fa-check"></span></td>
                        <td className="type"><span className="fa fa-check"></span></td>
                        <td className="notes">A string formatted as an ISO-8601 date that represents the end of usage. Omit if not available.</td>
                    </tr>
                    <tr>
                        <td className="attribute">phoneNumbers[]</td>
                        <td className="type"></td>
                        <td className="type"><span className="fa fa-check"></span></td>
                        <td className="type"><span className="fa fa-check"></span></td>
                        <td className="type"></td>
                        <td className="notes">An array of phone objects. Omit if not available.
                        </td>
                    </tr>
                    <tr>
                        <td className="attribute">phoneNumbers[].value</td>
                        <td className="type"></td>
                        <td className="type"><span className="fa fa-check"></span></td>
                        <td className="type"><span className="fa fa-check"></span></td>
                        <td className="type"></td>
                        <td className="notes">The phone number value.
                        </td>
                    </tr>
                    <tr>
                        <td className="attribute">phoneNumbers[].type</td>
                        <td className="type"></td>
                        <td className="type"><span className="fa fa-check"></span></td>
                        <td className="type"><span className="fa fa-check"></span></td>
                        <td className="type"></td>
                        <td className="notes">The phone type. Valid types are PHONE, FAX, CELL, OTHER. Default is PHONE.
                        </td>
                    </tr>
                    <tr>
                        <td className="attribute">phoneNumbers[].current</td>
                        <td className="type"></td>
                        <td className="type"><span className="fa fa-check"></span></td>
                        <td className="type"><span className="fa fa-check"></span></td>
                        <td className="type"></td>
                        <td className="notes">Boolean value that represents a current operational number. Default is true.
                        </td>
                    </tr>
                    <tr>
                        <td className="attribute">phoneNumbers[].startDate</td>
                        <td className="type"></td>
                        <td className="type"><span className="fa fa-check"></span></td>
                        <td className="type"><span className="fa fa-check"></span></td>
                        <td className="type"></td>
                        <td className="notes">A string formatted as an ISO-8601 date that represents the start date of the number. Omit if not available.
                        </td>
                    </tr>
                    <tr>
                        <td className="attribute">phoneNumbers[].endDate</td>
                        <td className="type"></td>
                        <td className="type"><span className="fa fa-check"></span></td>
                        <td className="type"><span className="fa fa-check"></span></td>
                        <td className="type"></td>
                        <td className="notes">A string formatted as an ISO-8601 date that represents the end date of the number. Omit if not available.
                        </td>
                    </tr>
                    <tr>
                        <td className="attribute">emails[]</td>
                        <td className="type"></td>
                        <td className="type"><span className="fa fa-check"></span></td>
                        <td className="type"><span className="fa fa-check"></span></td>
                        <td className="type"></td>
                        <td className="notes">An array of email objects. Omit if not available.
                        </td>
                    </tr>
                    <tr>
                        <td className="attribute">emails[].value</td>
                        <td className="type"></td>
                        <td className="type"><span className="fa fa-check"></span></td>
                        <td className="type"><span className="fa fa-check"></span></td>
                        <td className="type"></td>
                        <td className="notes">The email address.
                        </td>
                    </tr>
                    <tr>
                        <td className="attribute">emails[].type</td>
                        <td className="type"></td>
                        <td className="type"><span className="fa fa-check"></span></td>
                        <td className="type"><span className="fa fa-check"></span></td>
                        <td className="type"></td>
                        <td className="notes">The email type.<br/>
                        <br/>
                        Valid types are for an ORGANIZATION are: BUSINESS, SUPPORT, CONTACT, OTHER. Default is BUSINESS.<br/>
                        <br/>
                        Valid types for a PERSON are: BUSINESS, PERSONAL, HOME, OTHER. Default is BUSINESS.
                        </td>
                    </tr>
                    <tr>
                        <td className="attribute">emails[].current</td>
                        <td className="type"></td>
                        <td className="type"><span className="fa fa-check"></span></td>
                        <td className="type"><span className="fa fa-check"></span></td>
                        <td className="type"></td>
                        <td className="notes">Boolean value that represents a current operational email. Default is true.
                        </td>
                    </tr>
                    <tr>
                        <td className="attribute">emails[].startDate</td>
                        <td className="type"></td>
                        <td className="type"><span className="fa fa-check"></span></td>
                        <td className="type"><span className="fa fa-check"></span></td>
                        <td className="type"></td>
                        <td className="notes">A string formatted as an ISO-8601 date that represents the start date of the email. Omit if not available.
                        </td>
                    </tr>
                    <tr>
                        <td className="attribute">emails[].endDate</td>
                        <td className="type"></td>
                        <td className="type"><span className="fa fa-check"></span></td>
                        <td className="type"><span className="fa fa-check"></span></td>
                        <td className="type"></td>
                        <td className="notes">A string formatted as an ISO-8601 date that represents the end date of the email. Omit if not available.
                        </td>
                    </tr>
                    <tr>
                        <td className="attribute">legalEntityIds[] <span className="fa fa-search entity-search"></span></td>
                        <td className="type"></td>
                        <td className="type"></td>
                        <td className="type"><span className="fa fa-check"></span></td>
                        <td className="type"></td>
                        <td className="notes">An array of Legal Entity Identifiers (LEI) which is a 20-character identifier, defined by 
                            ISO 17442, that identifies distinct legal entities that engage in financial transactions. 
                            See: {miscUtils.createExternalLink('https://www.gleif.org/en/about-lei/iso-17442-the-lei-code-structure','ISO 17442')}.
                        </td>
                    </tr>
                    <tr>
                        <td className="attribute">isins[]</td>
                        <td className="type"></td>
                        <td className="type"></td>
                        <td className="type"><span className="fa fa-check"></span></td>
                        <td className="type"></td>
                        <td className="notes">An array of International Securities Identification Numbers (ISIN) that uniquely 
                            identifies a security. ISO 6166:2013
                        </td>
                    </tr>
                    <tr>
                        <td className="attribute">employerIdNumbers[] <span className="fa fa-search entity-search"></span></td>
                        <td className="type"></td>
                        <td className="type"></td>
                        <td className="type"><span className="fa fa-check"></span></td>
                        <td className="type"></td>
                        <td className="notes">An array of Employer Identification Numbers (EIN) also known as a Federal Tax Identification 
                            Number issued to businesses by the US Internal Revenue Service.
                        </td>
                    </tr>
                    <tr id="industryGroup">
                        <td className="attribute">industryGroup <span className="fa fa-star normalized"></span></td>
                        <td className="type"></td>
                        <td className="type"></td>
                        <td className="type"><span className="fa fa-check"></span></td>
                        <td className="type"></td>
                        <td className="notes">Parent object for an organization's Industry Group. Omit if not available.</td>
                    </tr>
                    <tr>
                        <td className="attribute">industryGroup.label <span className="fa fa-star normalized"></span></td>
                        <td className="type"></td>
                        <td className="type"></td>
                        <td className="type"><span className="fa fa-check"></span></td>
                        <td className="type"></td>
                        <td className="notes">Name for an organization's Industry Group. Omit if not available.
                        </td>
                    </tr>
                    <tr id="businessSector">
                        <td className="attribute">businessSector <span className="fa fa-star normalized"></span></td>
                        <td className="type"></td>
                        <td className="type"></td>
                        <td className="type"><span className="fa fa-check"></span></td>
                        <td className="type"></td>
                        <td className="notes">Parent object for an organization's Business Sector. Omit if not available.</td>
                    </tr>
                    <tr>
                        <td className="attribute">businessSector.label <span className="fa fa-star normalized"></span></td>
                        <td className="type"></td>
                        <td className="type"></td>
                        <td className="type"><span className="fa fa-check"></span></td>
                        <td className="type"></td>
                        <td className="notes">Name for an organization's Business Sector. Omit if not available.
                        </td>
                    </tr>
                    <tr id="economicSector">
                        <td className="attribute">economicSector <span className="fa fa-star normalized"></span></td>
                        <td className="type"></td>
                        <td className="type"></td>
                        <td className="type"><span className="fa fa-check"></span></td>
                        <td className="type"></td>
                        <td className="notes">Parent object for an organization's Economic Sector. Omit if not available.</td>
                    </tr>
                    <tr>
                        <td className="attribute">economicSector.label <span className="fa fa-star normalized"></span></td>
                        <td className="type"></td>
                        <td className="type"></td>
                        <td className="type"><span className="fa fa-check"></span></td>
                        <td className="type"></td>
                        <td className="notes">Name for an organization's Economic Sector. Omit if not available.
                        </td>
                    </tr>
                    <tr>
                        <td className="attribute">urls[] <span className="fa fa-search entity-search"></span></td>
                        <td className="type"></td>
                        <td className="type"><span className="fa fa-check"></span></td>
                        <td className="type"><span className="fa fa-check"></span></td>
                        <td className="type"><span className="fa fa-check"></span></td>
                        <td className="notes">An array of related public wiki urls. Empty array if no values available.</td>
                    </tr>
                    <tr>
                        <td className="attribute">imageUrls[]</td>
                        <td className="type"></td>
                        <td className="type"><span className="fa fa-check"></span></td>
                        <td className="type"><span className="fa fa-check"></span></td>
                        <td className="type"><span className="fa fa-check"></span></td>
                        <td className="notes">An array of related public images urls. Empty array if no values available.</td>
                    </tr>
                    <tr>
                        <td className="attribute">categories[] <span className="fa fa-star normalized"></span></td>
                        <td className="type"></td>
                        <td className="type"><span className="fa fa-check"></span></td>
                        <td className="type"><span className="fa fa-check"></span></td>
                        <td className="type"><span className="fa fa-check"></span></td>
                        <td className="notes">An array of categories associated with the entity. Empty array if no values available.</td>
                    </tr>
                    <tr>
                        <td className="attribute">instanceOf[]</td>
                        <td className="type"></td>
                        <td className="type"></td>
                        <td className="type"><span className="fa fa-check"></span></td>
                        <td className="type"><span className="fa fa-check"></span></td>
                        <td className="notes">An array of Wikidata instance type text labels. Omit if not available.</td>
                    </tr>
                    <tr>
                        <td className="attribute">incorporationDate <span className="fa fa-search entity-search"></span></td>
                        <td className="type"></td>
                        <td className="type"></td>
                        <td className="type"><span className="fa fa-check"></span></td>
                        <td className="type"></td>
                        <td className="notes">Organization incorporationDate date. Omit if not available.</td>
                    </tr>
                    <tr>
                        <td className="attribute">inceptionDate <span className="fa fa-search entity-search"></span></td>
                        <td className="type"></td>
                        <td className="type"></td>
                        <td className="type"><span className="fa fa-check"></span></td>
                        <td className="type"></td>
                        <td className="notes">Organization inception date. Omit if not available.</td>
                    </tr>
                    <tr id="location">
                        <td className="attribute">location</td>
                        <td className="type"></td>
                        <td className="type"></td>
                        <td className="type"><span className="fa fa-check"></span></td>
                        <td className="type"></td>
                        <td className="notes">Parent object for an organization's location information. Omit if is not available.</td>
                    </tr>
                    <tr>
                        <td className="attribute">location.latitude</td>
                        <td className="type"></td>
                        <td className="type"></td>
                        <td className="type"><span className="fa fa-check"></span></td>
                        <td className="type"></td>
                        <td className="notes">The latitude of the organization's location. Omit if not available.</td>
                    </tr>
                    <tr>
                        <td className="attribute">location.longitude</td>
                        <td className="type"></td>
                        <td className="type"></td>
                        <td className="type"><span className="fa fa-check"></span></td>
                        <td className="type"></td>
                        <td className="notes">The longitude of the organization's location. Omit if not available.</td>
                    </tr>
                    <tr>
                        <td className="attribute">location.countryLabel <span className="fa fa-search entity-search"></span></td>
                        <td className="type"></td>
                        <td className="type"></td>
                        <td className="type"><span className="fa fa-check"></span></td>
                        <td className="type"></td>
                        <td className="notes">The organization's location country. Omit if not available.</td>
                    </tr>
                    <tr>
                        <td className="attribute">location.countryCode</td>
                        <td className="type"></td>
                        <td className="type"></td>
                        <td className="type"><span className="fa fa-check"></span></td>
                        <td className="type"></td>
                        <td className="notes">The organization's two digit country code. Omit if not available.</td>
                    </tr>
                    <tr>
                        <td className="attribute">location.postalCode <span className="fa fa-search entity-search"></span></td>
                        <td className="type"></td>
                        <td className="type"></td>
                        <td className="type"><span className="fa fa-check"></span></td>
                        <td className="type"></td>
                        <td className="notes">The organization's location postal code. Omit if not available.</td>
                    </tr>
                    <tr>
                        <td className="attribute">location.admin1Label <span className="fa fa-search entity-search"></span></td>
                        <td className="type"></td>
                        <td className="type"></td>
                        <td className="type"><span className="fa fa-check"></span></td>
                        <td className="type"></td>
                        <td className="notes">The organization's location country's first administration level. Omit if not available.</td>
                    </tr>
                    <tr>
                        <td className="attribute">location.admin1Code <span className="fa fa-search entity-search"></span></td>
                        <td className="type"></td>
                        <td className="type"></td>
                        <td className="type"><span className="fa fa-check"></span></td>
                        <td className="type"></td>
                        <td className="notes">State or Province (Admin1 GENC Code). Omit if not available.</td>
                    </tr>
                    <tr>
                        <td className="attribute">location.cityLabel <span className="fa fa-search entity-search"></span></td>
                        <td className="type"></td>
                        <td className="type"></td>
                        <td className="type"><span className="fa fa-check"></span></td>
                        <td className="type"></td>
                        <td className="notes">The organization's location city. Omit if not available.</td>
                    </tr>
                    <tr>
                        <td className="attribute">location.streetAddress <span className="fa fa-search entity-search"></span> </td>
                        <td className="type"></td>
                        <td className="type"></td>
                        <td className="type"><span className="fa fa-check"></span></td>
                        <td className="type"></td>
                        <td className="notes">The organization's location street address. Omit if not available.</td>
                    </tr>
                    <tr id="registeredAddress">
                        <td className="attribute">registeredAddress</td>
                        <td className="type"></td>
                        <td className="type"></td>
                        <td className="type"><span className="fa fa-check"></span></td>
                        <td className="type"></td>
                        <td className="notes">Parent object for an organization's registeredAddress information. Omit if not available.</td>
                    </tr>
                    <tr>
                        <td className="attribute">registeredAddress.latitude</td>
                        <td className="type"></td>
                        <td className="type"></td>
                        <td className="type"><span className="fa fa-check"></span></td>
                        <td className="type"></td>
                        <td className="notes">The latitude of the organization's registeredAddress. Omit if not available.</td>
                    </tr>
                    <tr>
                        <td className="attribute">registeredAddress.longitude</td>
                        <td className="type"></td>
                        <td className="type"></td>
                        <td className="type"><span className="fa fa-check"></span></td>
                        <td className="type"></td>
                        <td className="notes">The longitude of the organization's registeredAddress. Omit if not available.</td>
                    </tr>
                    <tr>
                        <td className="attribute">registeredAddress.countryLabel <span className="fa fa-search entity-search"></span></td>
                        <td className="type"></td>
                        <td className="type"></td>
                        <td className="type"><span className="fa fa-check"></span></td>
                        <td className="type"></td>
                        <td className="notes">The organization's registeredAddress country. Omit if not available.</td>
                    </tr>
                    <tr>
                        <td className="attribute">registeredAddress.countryCode</td>
                        <td className="type"></td>
                        <td className="type"></td>
                        <td className="type"><span className="fa fa-check"></span></td>
                        <td className="type"></td>
                        <td className="notes">The organization's registeredAddress two digit country code. Omit if not available.</td>
                    </tr>
                    <tr>
                        <td className="attribute">registeredAddress.postalCode <span className="fa fa-search entity-search"></span></td>
                        <td className="type"></td>
                        <td className="type"></td>
                        <td className="type"><span className="fa fa-check"></span></td>
                        <td className="type"></td>
                        <td className="notes">The organization's registeredAddress postal code. Omit if not available.</td>
                    </tr>
                    <tr>
                        <td className="attribute">registeredAddress.admin1Label <span className="fa fa-search entity-search"></span></td>
                        <td className="type"></td>
                        <td className="type"></td>
                        <td className="type"><span className="fa fa-check"></span></td>
                        <td className="type"></td>
                        <td className="notes">The organization's registeredAddress country's first administration level. Omit if not available.</td>
                    </tr>
                    <tr>
                        <td className="attribute">registeredAddress.admin1Code <span className="fa fa-search entity-search"></span></td>
                        <td className="type"></td>
                        <td className="type"></td>
                        <td className="type"><span className="fa fa-check"></span></td>
                        <td className="type"></td>
                        <td className="notes">State or Province (Admin1 GENC Code). Omit if not available.</td>
                    </tr>
                    <tr>
                        <td className="attribute">registeredAddress.cityLabel <span className="fa fa-search entity-search"></span></td>
                        <td className="type"></td>
                        <td className="type"></td>
                        <td className="type"><span className="fa fa-check"></span></td>
                        <td className="type"></td>
                        <td className="notes">The organization's registeredAddress city. Omit if not available.</td>
                    </tr>
                    <tr>
                        <td className="attribute">registeredAddress.streetAddress <span className="fa fa-search entity-search"></span> </td>
                        <td className="type"></td>
                        <td className="type"></td>
                        <td className="type"><span className="fa fa-check"></span></td>
                        <td className="type"></td>
                        <td className="notes">The organization's registeredAddress street address. Omit if not available.</td>
                    </tr>
                    <tr>
                        <td className="attribute">owners[]</td>
                        <td className="type"></td>
                        <td className="type"></td>
                        <td className="type"><span className="fa fa-check"></span></td>
                        <td className="type"></td>
                        <td className="notes">A text array of the organization's owners. Omit if not available.</td>
                    </tr>
                    <tr>
                        <td className="attribute">genres[]</td>
                        <td className="type"></td>
                        <td className="type"></td>
                        <td className="type"><span className="fa fa-check"></span></td>
                        <td className="type"></td>
                        <td className="notes">A text array of the organization's genres. Omit if not available.</td>
                    </tr>
                    <tr>
                        <td className="attribute">legalForms[]</td>
                        <td className="type"></td>
                        <td className="type"></td>
                        <td className="type"><span className="fa fa-check"></span></td>
                        <td className="type"></td>
                        <td className="notes">A text array of the organization's name legal forms. Omit if not available.</td>
                    </tr>
                    <tr>
                        <td className="attribute">industries[] <span className="fa fa-star normalized"></span> <span className="fa fa-search entity-search"></span></td>
                        <td className="type"></td>
                        <td className="type"></td>
                        <td className="type"><span className="fa fa-check"></span></td>
                        <td className="type"></td>
                        <td className="notes">A text array of the organization's associated industries. Omit if not available.</td>
                    </tr>
                    <tr>
                        <td className="attribute">products[] <span className="fa fa-star normalized"></span> <span className="fa fa-search entity-search"></span></td>
                        <td className="type"></td>
                        <td className="type"></td>
                        <td className="type"><span className="fa fa-check"></span></td>
                        <td className="type"></td>
                        <td className="notes">A array of the organization's associated products. Products have a label and finchID if available. Omit if not available.</td>
                    </tr>
                    <tr>
                        <td className="attribute">founders[] <span className="fa fa-star normalized"></span> <span className="fa fa-search entity-search"></span></td>
                        <td className="type"></td>
                        <td className="type"></td>
                        <td className="type"><span className="fa fa-check"></span></td>
                        <td className="type"></td>
                        <td className="notes">A text array of the organization's founders. Omit if not available.</td>
                    </tr>
                    <tr>
                        <td className="attribute">dateDissolved <span className="fa fa-search entity-search"></span></td>
                        <td className="type"></td>
                        <td className="type"></td>
                        <td className="type"><span className="fa fa-check"></span></td>
                        <td className="type"></td>
                        <td className="notes">If applicable, the date the organization was dissolved formatted as an ISO 8601 date string. Omit if not available.</td>
                    </tr>
                    <tr>
                        <td className="attribute">politicalIdeologies[] <span className="fa fa-star normalized"></span></td>
                        <td className="type"></td>
                        <td className="type"></td>
                        <td className="type"><span className="fa fa-check"></span></td>
                        <td className="type"></td>
                        <td className="notes">A text array of the organization's political ideologies. Omit if not available.</td>
                    </tr>
                    <tr id="stocks">
                        <td className="attribute">stocks[]</td>
                        <td className="type"></td>
                        <td className="type"></td>
                        <td className="type"><span className="fa fa-check"></span></td>
                        <td className="type"></td>
                        <td className="notes">An array of stock objects. Omit if none available.</td>
                    </tr>
                    <tr>
                        <td className="attribute">stocks[].exchange</td>
                        <td className="type"></td>
                        <td className="type"></td>
                        <td className="type"><span className="fa fa-check"></span></td>
                        <td className="type"></td>
                        <td className="notes">A text label for the exchange market. Omit if not available.</td>
                    </tr>
                    <tr>
                        <td className="attribute">stocks[].tickerSymbol <span className="fa fa-search entity-search"></span></td>
                        <td className="type"></td>
                        <td className="type"></td>
                        <td className="type"><span className="fa fa-check"></span></td>
                        <td className="type"></td>
                        <td className="notes">The ticker symbol. Omit if not available.</td>
                    </tr>
                    <tr>
                        <td className="attribute">stocks[].mic</td>
                        <td className="type"></td>
                        <td className="type"></td>
                        <td className="type"><span className="fa fa-check"></span></td>
                        <td className="type"></td>
                        <td className="notes">The Market Identifier Code. Omit if not available. See {miscUtils.createExternalLink('https://en.wikipedia.org/wiki/Market_Identifier_Code', 'MIC')} for more information.</td>
                    </tr>
                    <tr>
                        <td className="attribute">stocks[].operatingMic</td>
                        <td className="type"></td>
                        <td className="type"></td>
                        <td className="type"><span className="fa fa-check"></span></td>
                        <td className="type"></td>
                        <td className="notes">The exchange Market Identifier Code. Omit if not available. See {miscUtils.createExternalLink('https://en.wikipedia.org/wiki/Market_Identifier_Code', 'MIC')} for more information.</td>
                    </tr>
                    <tr>
                        <td className="attribute">stocks[].primary</td>
                        <td className="type"></td>
                        <td className="type"></td>
                        <td className="type"><span className="fa fa-check"></span></td>
                        <td className="type"></td>
                        <td className="notes">Boolean value that represents if the stock is the primary. Default is true.</td>
                    </tr>
                    <tr>
                        <td className="attribute">stocks[].current</td>
                        <td className="type"></td>
                        <td className="type"></td>
                        <td className="type"><span className="fa fa-check"></span></td>
                        <td className="type"></td>
                        <td className="notes">Boolean value that represents a currently traded stock. Default is true.</td>
                    </tr>
                    <tr>
                        <td className="attribute">parentOrganizations[] <span className="fa fa-star normalized"></span> <span className="fa fa-search entity-search"></span></td>
                        <td className="type"></td>
                        <td className="type"></td>
                        <td className="type"><span className="fa fa-check"></span></td>
                        <td className="type"></td>
                        <td className="notes">A text array of the parent organizations. Omit if not available.</td>
                    </tr>
                    <tr>
                        <td className="attribute">chairPersons[] <span className="fa fa-star normalized"></span> <span className="fa fa-search entity-search"></span></td>
                        <td className="type"></td>
                        <td className="type"></td>
                        <td className="type"><span className="fa fa-check"></span></td>
                        <td className="type"></td>
                        <td className="notes">A text array of the organization's chair persons. Omit if not available.</td>
                    </tr>
                    <tr>
                        <td className="attribute">subsidiaries[] <span className="fa fa-star normalized"></span> <span className="fa fa-search entity-search"></span></td>
                        <td className="type"></td>
                        <td className="type"></td>
                        <td className="type"><span className="fa fa-check"></span></td>
                        <td className="type"></td>
                        <td className="notes">A text array of the organization's subsidiaries. Omit if not available.</td>
                    </tr>
                    <tr>
                        <td className="attribute">employeeCount</td>
                        <td className="type"></td>
                        <td className="type"></td>
                        <td className="type"><span className="fa fa-check"></span></td>
                        <td className="type"></td>
                        <td className="notes">Number of employees expressed as an integer value. Omit if not available.</td>
                    </tr>
                    <tr>
                        <td className="attribute">chiefExecutiveOfficers[] <span className="fa fa-star normalized"></span> <span className="fa fa-search entity-search"></span></td>
                        <td className="type"></td>
                        <td className="type"></td>
                        <td className="type"><span className="fa fa-check"></span></td>
                        <td className="type"></td>
                        <td className="notes">An ordered text array by most recent chief executive officers. Omit if not available.</td>
                    </tr>
                    <tr>
                        <td className="attribute">partOf[] <span className="fa fa-star normalized"></span></td>
                        <td className="type"></td>
                        <td className="type"><span className="fa fa-check"></span></td>
                        <td className="type"><span className="fa fa-check"></span></td>
                        <td className="type"></td>
                        <td className="notes">An array of Wikidata part of text labels. Omit if not available.</td>
                    </tr>
                    <tr>
                        <td className="attribute">genres[]</td>
                        <td className="type"></td>
                        <td className="type"><span className="fa fa-check"></span></td>
                        <td className="type"></td>
                        <td className="type"></td>
                        <td className="notes">An array of person genres.</td>
                    </tr>
                    <tr>
                        <td className="attribute">genders[] <span className="fa fa-search entity-search"></span></td>
                        <td className="type"></td>
                        <td className="type"><span className="fa fa-check"></span></td>
                        <td className="type"></td>
                        <td className="type"></td>
                        <td className="notes">An array of person genders. Ordered descending by most recent.</td>
                    </tr>
                    <tr>
                        <td className="attribute">citizenships[] <span className="fa fa-search entity-search"></span></td>
                        <td className="type"></td>
                        <td className="type"><span className="fa fa-check"></span></td>
                        <td className="type"></td>
                        <td className="type"></td>
                        <td className="notes">List of countries of citizenship including country label and country code</td>
                    </tr>
                    <tr>
                        <td className="attribute">citizenshipCountries[] <span className="fa fa-search entity-search"></span></td>
                        <td className="type"></td>
                        <td className="type"><span className="fa fa-check"></span></td>
                        <td className="type"></td>
                        <td className="type"></td>
                        <td className="notes">Country of citizenship.</td>
                    </tr>
                    <tr>
                        <td className="attribute">birthName <span className="fa fa-star normalized"></span></td>
                        <td className="type"></td>
                        <td className="type"><span className="fa fa-check"></span></td>
                        <td className="type"></td>
                        <td className="type"></td>
                        <td className="notes">Name at birth.</td>
                    </tr>
                    <tr>
                        <td className="attribute">givenNames[] <span className="fa fa-star normalized"></span></td>
                        <td className="type"></td>
                        <td className="type"><span className="fa fa-check"></span></td>
                        <td className="type"></td>
                        <td className="type"></td>
                        <td className="notes">An array of given names.</td>
                    </tr>
                    <tr>
                        <td className="attribute">familyNames[] <span className="fa fa-star normalized"></span></td>
                        <td className="type"></td>
                        <td className="type"><span className="fa fa-check"></span></td>
                        <td className="type"></td>
                        <td className="type"></td>
                        <td className="notes">An array of family names.</td>
                    </tr>
                    <tr>
                        <td className="attribute">birthDate <span className="fa fa-search entity-search"></span></td>
                        <td className="type"></td>
                        <td className="type"><span className="fa fa-check"></span></td>
                        <td className="type"></td>
                        <td className="type"></td>
                        <td className="notes">Date of birth.</td>
                    </tr>
                    <tr>
                        <td className="attribute">deathDate <span className="fa fa-search entity-search"></span></td>
                        <td className="type"></td>
                        <td className="type"><span className="fa fa-check"></span></td>
                        <td className="type"></td>
                        <td className="type"></td>
                        <td className="notes">Date of death.</td>
                    </tr>
                    <tr>
                        <td className="attribute">fatherName <span className="fa fa-star normalized"></span> <span className="fa fa-search entity-search"></span></td>
                        <td className="type"></td>
                        <td className="type"><span className="fa fa-check"></span></td>
                        <td className="type"></td>
                        <td className="type"></td>
                        <td className="notes">Father's name.</td>
                    </tr>
                    <tr>
                        <td className="attribute">motherName <span className="fa fa-star normalized"></span> <span className="fa fa-search entity-search"></span></td>
                        <td className="type"></td>
                        <td className="type"><span className="fa fa-check"></span></td>
                        <td className="type"></td>
                        <td className="type"></td>
                        <td className="notes">Mother's name.</td>
                    </tr>
                    <tr>
                        <td className="attribute">spousesNames[] <span className="fa fa-star normalized"></span> <span className="fa fa-search entity-search"></span></td>
                        <td className="type"></td>
                        <td className="type"><span className="fa fa-check"></span></td>
                        <td className="type"></td>
                        <td className="type"></td>
                        <td className="notes">An array of spouses' names.</td>
                    </tr>
                    <tr>
                        <td className="attribute">partnersNames[] <span className="fa fa-star normalized"></span> <span className="fa fa-search entity-search"></span></td>
                        <td className="type"></td>
                        <td className="type"><span className="fa fa-check"></span></td>
                        <td className="type"></td>
                        <td className="type"></td>
                        <td className="notes">An array of partners' names.</td>
                    </tr>
                    <tr>
                        <td className="attribute">childNames[] <span className="fa fa-star normalized"></span></td>
                        <td className="type"></td>
                        <td className="type"><span className="fa fa-check"></span></td>
                        <td className="type"></td>
                        <td className="type"></td>
                        <td className="notes">An array of child's names.</td>
                    </tr>
                    <tr>
                        <td className="attribute">siblingsNames[] <span className="fa fa-star normalized"></span> <span className="fa fa-search entity-search"></span></td>
                        <td className="type"></td>
                        <td className="type"><span className="fa fa-check"></span></td>
                        <td className="type"></td>
                        <td className="type"></td>
                        <td className="notes">An array of siblings' names.</td>
                    </tr>
                    <tr>
                        <td className="attribute">relativesNames[] <span className="fa fa-star normalized"></span></td>
                        <td className="type"></td>
                        <td className="type"><span className="fa fa-check"></span></td>
                        <td className="type"></td>
                        <td className="type"></td>
                        <td className="notes">An array of relatives' names.</td>
                    </tr>
                    <tr>
                        <td className="attribute">nativeLanguages[]</td>
                        <td className="type"></td>
                        <td className="type"><span className="fa fa-check"></span></td>
                        <td className="type"></td>
                        <td className="type"></td>
                        <td className="notes">An array of native languages.</td>
                    </tr>
                    <tr>
                        <td className="attribute">occupations[] <span className="fa fa-star normalized"></span> <span className="fa fa-search entity-search"></span></td>
                        <td className="type"></td>
                        <td className="type"><span className="fa fa-check"></span></td>
                        <td className="type"></td>
                        <td className="type"></td>
                        <td className="notes">An array of occupations.</td>
                    </tr>
                    <tr>
                        <td className="attribute">heldPositions[] <span className="fa fa-star normalized"></span> <span className="fa fa-search entity-search"></span></td>
                        <td className="type"></td>
                        <td className="type"><span className="fa fa-check"></span></td>
                        <td className="type"></td>
                        <td className="type"></td>
                        <td className="notes">An array of held positions.</td>
                    </tr>
                    <tr>
                        <td className="attribute">attendedSchools[] <span className="fa fa-star normalized"></span></td>
                        <td className="type"></td>
                        <td className="type"><span className="fa fa-check"></span></td>
                        <td className="type"></td>
                        <td className="type"></td>
                        <td className="notes">An array of objects that represent an attended school.</td>
                    </tr>
                    <tr>
                        <td className="attribute">attendedSchools[].label <span className="fa fa-search entity-search"></span></td>
                        <td className="type"></td>
                        <td className="type"><span className="fa fa-check"></span></td>
                        <td className="type"></td>
                        <td className="type"></td>
                        <td className="notes">The name of the attended school.</td>
                    </tr>
                    <tr>
                        <td className="attribute">attendedSchools[].finchId</td>
                        <td className="type"></td>
                        <td className="type"><span className="fa fa-check"></span></td>
                        <td className="type"></td>
                        <td className="type"></td>
                        <td className="notes">The Finch KB id of the attended school. Omit if not available.</td>
                    </tr>
                    <tr>
                        <td className="attribute">attendedSchools[].permId</td>
                        <td className="type"></td>
                        <td className="type"><span className="fa fa-check"></span></td>
                        <td className="type"></td>
                        <td className="type"></td>
                        <td className="notes">The Thomson Reuters perm id of the attended school. Omit if not available.</td>
                    </tr>
                    <tr>
                        <td className="attribute">attendedSchools[].type</td>
                        <td className="type"></td>
                        <td className="type"><span className="fa fa-check"></span></td>
                        <td className="type"></td>
                        <td className="type"></td>
                        <td className="notes">The type of degree earned. Omit if not available.</td>
                    </tr>
                    <tr>
                        <td className="attribute">attendedSchools[].title</td>
                        <td className="type"></td>
                        <td className="type"><span className="fa fa-check"></span></td>
                        <td className="type"></td>
                        <td className="type"></td>
                        <td className="notes">The area of study (e.g. major). Omit if not available.</td>
                    </tr>
                    <tr>
                        <td className="attribute">attendedSchools[].current</td>
                        <td className="type"></td>
                        <td className="type"><span className="fa fa-check"></span></td>
                        <td className="type"></td>
                        <td className="type"></td>
                        <td className="notes">Boolean value that represents current enrollment in the school.</td>
                    </tr>
                    <tr>
                        <td className="attribute">attendedSchools[].startDate</td>
                        <td className="type"></td>
                        <td className="type"><span className="fa fa-check"></span></td>
                        <td className="type"></td>
                        <td className="type"></td>
                        <td className="notes">A string formatted as an ISO-8601 date that represents the start date of enrollment. Omit if not available.</td>
                    </tr>
                    <tr>
                        <td className="attribute">attendedSchools[].endDate</td>
                        <td className="type"></td>
                        <td className="type"><span className="fa fa-check"></span></td>
                        <td className="type"></td>
                        <td className="type"></td>
                        <td className="notes">A string formatted as an ISO-8601 date that represents completion. Omit if not available.</td>
                    </tr>
                    <tr>
                        <td className="attribute">ethnicGroups[]</td>
                        <td className="type"></td>
                        <td className="type"><span className="fa fa-check"></span></td>
                        <td className="type"></td>
                        <td className="type"></td>
                        <td className="notes">An array of ethnic groups.</td>
                    </tr>
                    <tr>
                        <td className="attribute">religiousAffiliations[] <span className="fa fa-star normalized"></span> <span className="fa fa-search entity-search"></span></td>
                        <td className="type"></td>
                        <td className="type"><span className="fa fa-check"></span></td>
                        <td className="type"></td>
                        <td className="type"></td>
                        <td className="notes">An array of religious affiliations.</td>
                    </tr>
                    <tr>
                        <td className="attribute">numberOfChildren</td>
                        <td className="type"></td>
                        <td className="type"><span className="fa fa-check"></span></td>
                        <td className="type"></td>
                        <td className="type"></td>
                        <td className="notes">Children count as an integer value.</td>
                    </tr>
                    <tr>
                        <td className="attribute">memberOf[] <span className="fa fa-star normalized"></span> <span className="fa fa-search entity-search"></span></td>
                        <td className="type"></td>
                        <td className="type"><span className="fa fa-check"></span></td>
                        <td className="type"></td>
                        <td className="type"></td>
                        <td className="notes">An array of groups or organizations to which this person belongs.</td>
                    </tr>
                    <tr>
                        <td className="attribute">employers[] <span className="fa fa-star normalized"></span></td>
                        <td className="type"></td>
                        <td className="type"><span className="fa fa-check"></span></td>
                        <td className="type"></td>
                        <td className="type"></td>
                        <td className="notes">An array of objects that represent organizations that have employed this person.</td>
                    </tr>
                    <tr>
                        <td className="attribute">employers[].label <span className="fa fa-search entity-search"></span></td>
                        <td className="type"></td>
                        <td className="type"><span className="fa fa-check"></span></td>
                        <td className="type"></td>
                        <td className="type"></td>
                        <td className="notes">The name of the employer.</td>
                    </tr>
                    <tr>
                        <td className="attribute">employers[].finchId</td>
                        <td className="type"></td>
                        <td className="type"><span className="fa fa-check"></span></td>
                        <td className="type"></td>
                        <td className="type"></td>
                        <td className="notes">The Finch KB id of the employer if it exists.</td>
                    </tr>
                    <tr>
                        <td className="attribute">employers[].permId</td>
                        <td className="type"></td>
                        <td className="type"><span className="fa fa-check"></span></td>
                        <td className="type"></td>
                        <td className="type"></td>
                        <td className="notes">The Thomson Reuters perm id of the employer if it exists.</td>
                    </tr>
                    <tr>
                        <td className="attribute">employers[].type</td>
                        <td className="type"></td>
                        <td className="type"><span className="fa fa-check"></span></td>
                        <td className="type"></td>
                        <td className="type"></td>
                        <td className="notes">The generic type of position (e.g. President, CEO, Founder, etc). Omit if not available.</td>
                    </tr>
                    <tr>
                        <td className="attribute">employers[].title</td>
                        <td className="type"></td>
                        <td className="type"><span className="fa fa-check"></span></td>
                        <td className="type"></td>
                        <td className="type"></td>
                        <td className="notes">The individuals full title in the organization. Omit if not available.</td>
                    </tr>
                    <tr>
                        <td className="attribute">employers[].current</td>
                        <td className="type"></td>
                        <td className="type"><span className="fa fa-check"></span></td>
                        <td className="type"></td>
                        <td className="type"></td>
                        <td className="notes">Boolean value that represents current employment status.</td>
                    </tr>
                    <tr>
                        <td className="attribute">employers[].startDate</td>
                        <td className="type"></td>
                        <td className="type"><span className="fa fa-check"></span></td>
                        <td className="type"></td>
                        <td className="type"></td>
                        <td className="notes">A string formatted as an ISO-8601 date that represents the start of employment. Omit if not available.</td>
                    </tr>
                    <tr>
                        <td className="attribute">employers[].endDate</td>
                        <td className="type"></td>
                        <td className="type"><span className="fa fa-check"></span></td>
                        <td className="type"></td>
                        <td className="type"></td>
                        <td className="notes">A string formatted as an ISO-8601 date that represents end of employment. Omit if not available.</td>
                    </tr>
                    <tr>
                        <td className="attribute">politicalParties[] <span className="fa fa-star normalized"></span></td>
                        <td className="type"></td>
                        <td className="type"><span className="fa fa-check"></span></td>
                        <td className="type"></td>
                        <td className="type"></td>
                        <td className="notes">An array of objects that represent political parties to which this person is affiliated.</td>
                    </tr>
                    <tr>
                        <td className="attribute">politicalParties[].label <span className="fa fa-search entity-search"></span></td>
                        <td className="type"></td>
                        <td className="type"><span className="fa fa-check"></span></td>
                        <td className="type"></td>
                        <td className="type"></td>
                        <td className="notes">The name of the political party.</td>
                    </tr>
                    <tr>
                        <td className="attribute">politicalParties[].finchId</td>
                        <td className="type"></td>
                        <td className="type"><span className="fa fa-check"></span></td>
                        <td className="type"></td>
                        <td className="type"></td>
                        <td className="notes">The Finch KB id of the political party if it exists.</td>
                    </tr>
                    <tr>
                        <td className="attribute">politicalParties[].permId</td>
                        <td className="type"></td>
                        <td className="type"><span className="fa fa-check"></span></td>
                        <td className="type"></td>
                        <td className="type"></td>
                        <td className="notes">The Thomson Reuters perm id of the political party if it exists.</td>
                    </tr>
                    <tr>
                        <td className="attribute">allegiances[] <span className="fa fa-star normalized"></span></td>
                        <td className="type"></td>
                        <td className="type"><span className="fa fa-check"></span></td>
                        <td className="type"></td>
                        <td className="type"></td>
                        <td className="notes">An array of groups to which this person swears allegiance.</td>
                    </tr>
                    <tr>
                        <td className="attribute">deathCauses[]</td>
                        <td className="type"></td>
                        <td className="type"><span className="fa fa-check"></span></td>
                        <td className="type"></td>
                        <td className="type"></td>
                        <td className="notes">An array of death causes.</td>
                    </tr>
                    <tr>
                        <td className="attribute">sportsTeams[] <span className="fa fa-star normalized"></span></td>
                        <td className="type"></td>
                        <td className="type"><span className="fa fa-check"></span></td>
                        <td className="type"></td>
                        <td className="type"></td>
                        <td className="notes">An array of objects that represent sports teams to which this person is affiliated.</td>
                    </tr>
                    <tr>
                        <td className="attribute">sportsTeams[].label</td>
                        <td className="type"></td>
                        <td className="type"><span className="fa fa-check"></span></td>
                        <td className="type"></td>
                        <td className="type"></td>
                        <td className="notes">The name of the sports team.</td>
                    </tr>
                    <tr>
                        <td className="attribute">sportsTeams[].finchId</td>
                        <td className="type"></td>
                        <td className="type"><span className="fa fa-check"></span></td>
                        <td className="type"></td>
                        <td className="type"></td>
                        <td className="notes">The Finch KB id of the sports team if it exists.</td>
                    </tr>
                    <tr>
                        <td className="attribute">sportsTeams[].permId</td>
                        <td className="type"></td>
                        <td className="type"><span className="fa fa-check"></span></td>
                        <td className="type"></td>
                        <td className="type"></td>
                        <td className="notes">The Thomson Reuters perm id of the sports team if it exists.</td>
                    </tr>
                    <tr>
                        <td className="attribute">sportAffiliations[] <span className="fa fa-star normalized"></span></td>
                        <td className="type"></td>
                        <td className="type"><span className="fa fa-check"></span></td>
                        <td className="type"></td>
                        <td className="type"></td>
                        <td className="notes">An array of sports with which this person is affiliated.</td>
                    </tr>
                    <tr>
                        <td className="attribute">sportSpecialities[] <span className="fa fa-star normalized"></span></td>
                        <td className="type"></td>
                        <td className="type"><span className="fa fa-check"></span></td>
                        <td className="type"></td>
                        <td className="type"></td>
                        <td className="notes">An array of positions played on team / specialties.</td>
                    </tr>
                    <tr>
                        <td className="attribute">militaryBranches[] <span className="fa fa-star normalized"></span></td>
                        <td className="type"></td>
                        <td className="type"><span className="fa fa-check"></span></td>
                        <td className="type"></td>
                        <td className="type"></td>
                        <td className="notes">An array of military branches with which this person is affiliated.</td>
                    </tr>
                    <tr>
                        <td className="attribute">militaryRanks[]</td>
                        <td className="type"></td>
                        <td className="type"><span className="fa fa-check"></span></td>
                        <td className="type"></td>
                        <td className="type"></td>
                        <td className="notes">An array of military ranks held by this person.</td>
                    </tr>
                    <tr>
                        <td className="attribute">academicDegrees[]</td>
                        <td className="type"></td>
                        <td className="type"><span className="fa fa-check"></span></td>
                        <td className="type"></td>
                        <td className="type"></td>
                        <td className="notes">An array of academic degrees earned by this person.</td>
                    </tr>
                    <tr>
                        <td className="attribute">workFields[] <span className="fa fa-star normalized"></span></td>
                        <td className="type"></td>
                        <td className="type"><span className="fa fa-check"></span></td>
                        <td className="type"></td>
                        <td className="type"></td>
                        <td className="notes">An array of fields of work.</td>
                    </tr>
                    <tr>
                        <td className="attribute">ownedOrganizations[] <span className="fa fa-star normalized"></span></td>
                        <td className="type"></td>
                        <td className="type"><span className="fa fa-check"></span></td>
                        <td className="type"></td>
                        <td className="type"></td>
                        <td className="notes">An array of objects that represent organizations owned.</td>
                    </tr>
                    <tr>
                        <td className="attribute">ownedOrganizations[].label <span className="fa fa-search entity-search"></span></td>
                        <td className="type"></td>
                        <td className="type"><span className="fa fa-check"></span></td>
                        <td className="type"></td>
                        <td className="type"></td>
                        <td className="notes">The name of the organization owned.</td>
                    </tr>
                    <tr>
                        <td className="attribute">ownedOrganizations[].finchId</td>
                        <td className="type"></td>
                        <td className="type"><span className="fa fa-check"></span></td>
                        <td className="type"></td>
                        <td className="type"></td>
                        <td className="notes">The Finch KB id of the organization owned if it exists.</td>
                    </tr>
                    <tr>
                        <td className="attribute">ownedOrganizations[].permId</td>
                        <td className="type"></td>
                        <td className="type"><span className="fa fa-check"></span></td>
                        <td className="type"></td>
                        <td className="type"></td>
                        <td className="notes">The Thomson Reuters perm id of the organization owned if it exists.</td>
                    </tr>
                    <tr>
                        <td className="attribute">ownedOrganizations[].type</td>
                        <td className="type"></td>
                        <td className="type"><span className="fa fa-check"></span></td>
                        <td className="type"></td>
                        <td className="type"></td>
                        <td className="notes">Type of owner. Valid values are Owner or Co-Owner. Omit if not available.</td>
                    </tr>
                    <tr>
                        <td className="attribute">ownedOrganizations[].title</td>
                        <td className="type"></td>
                        <td className="type"><span className="fa fa-check"></span></td>
                        <td className="type"></td>
                        <td className="type"></td>
                        <td className="notes">The individuals full title in the organization. Omit if not available.</td>
                    </tr>
                    <tr>
                        <td className="attribute">ownedOrganizations[].current</td>
                        <td className="type"></td>
                        <td className="type"><span className="fa fa-check"></span></td>
                        <td className="type"></td>
                        <td className="type"></td>
                        <td className="notes">Boolean value that represents current employment status.</td>
                    </tr>
                    <tr>
                        <td className="attribute">ownedOrganizations[].startDate</td>
                        <td className="type"></td>
                        <td className="type"><span className="fa fa-check"></span></td>
                        <td className="type"></td>
                        <td className="type"></td>
                        <td className="notes">A string formatted as an ISO-8601 date that represents the start of employment. Omit if not available.</td>
                    </tr>
                    <tr>
                        <td className="attribute">ownedOrganizations[].endDate</td>
                        <td className="type"></td>
                        <td className="type"><span className="fa fa-check"></span></td>
                        <td className="type"></td>
                        <td className="type"></td>
                        <td className="notes">A string formatted as an ISO-8601 date that represents end of employment. Omit if not available.</td>
                    </tr>
                    <tr>
                        <td className="attribute">residenceLocation.latitude</td>
                        <td className="type"></td>
                        <td className="type"><span className="fa fa-check"></span></td>
                        <td className="type"></td>
                        <td className="type"></td>
                        <td className="notes">Residence latitude of this person.</td>
                    </tr>
                    <tr>
                        <td className="attribute">residenceLocation.longitude</td>
                        <td className="type"></td>
                        <td className="type"><span className="fa fa-check"></span></td>
                        <td className="type"></td>
                        <td className="type"></td>
                        <td className="notes">Residence longitude of this person.</td>
                    </tr>
                    <tr>
                        <td className="attribute">residenceLocation.countryLabel <span className="fa fa-search entity-search"></span></td>
                        <td className="type"></td>
                        <td className="type"><span className="fa fa-check"></span></td>
                        <td className="type"></td>
                        <td className="type"></td>
                        <td className="notes">Residence country label of this person.</td>
                    </tr>
                    <tr>
                        <td className="attribute">residenceLocation.countryCode</td>
                        <td className="type"></td>
                        <td className="type"><span className="fa fa-check"></span></td>
                        <td className="type"></td>
                        <td className="type"></td>
                        <td className="notes">Residence two digit country code. Omit if not available.</td>
                    </tr>
                    <tr>
                        <td className="attribute">residenceLocation.postalCode <span className="fa fa-search entity-search"></span></td>
                        <td className="type"></td>
                        <td className="type"><span className="fa fa-check"></span></td>
                        <td className="type"></td>
                        <td className="type"></td>
                        <td className="notes">Residence postal code of this person.</td>
                    </tr>
                    <tr>
                        <td className="attribute">residenceLocation.admin1Label <span className="fa fa-search entity-search"></span></td>
                        <td className="type"></td>
                        <td className="type"><span className="fa fa-check"></span></td>
                        <td className="type"></td>
                        <td className="type"></td>
                        <td className="notes">Residence admin1 label of this person.</td>
                    </tr>
                    <tr>
                        <td className="attribute">residenceLocation.admin1Code <span className="fa fa-search entity-search"></span></td>
                        <td className="type"></td>
                        <td className="type"><span className="fa fa-check"></span></td>
                        <td className="type"></td>
                        <td className="type"></td>
                        <td className="notes">State or Province code (Admin1 GENC code).</td>
                    </tr>
                    <tr>
                        <td className="attribute">residenceLocation.cityLabel <span className="fa fa-search entity-search"></span></td>
                        <td className="type"></td>
                        <td className="type"><span className="fa fa-check"></span></td>
                        <td className="type"></td>
                        <td className="type"></td>
                        <td className="notes">City.</td>
                    </tr>
                    <tr>
                        <td className="attribute">residenceLocation.name</td>
                        <td className="type"></td>
                        <td className="type"><span className="fa fa-check"></span></td>
                        <td className="type"></td>
                        <td className="type"></td>
                        <td className="notes">Residence name of this person.</td>
                    </tr>
                    <tr>
                        <td className="attribute">residenceLocation.streetAddress <span className="fa fa-search entity-search"></span></td>
                        <td className="type"></td>
                        <td className="type"><span className="fa fa-check"></span></td>
                        <td className="type"></td>
                        <td className="type"></td>
                        <td className="notes">Residence street address of this person.</td>
                    </tr>
                    <tr>
                        <td className="attribute">workLocation.latitude</td>
                        <td className="type"></td>
                        <td className="type"><span className="fa fa-check"></span></td>
                        <td className="type"></td>
                        <td className="type"></td>
                        <td className="notes">Work location latitude of this person.</td>
                    </tr>
                    <tr>
                        <td className="attribute">workLocation.longitude</td>
                        <td className="type"></td>
                        <td className="type"><span className="fa fa-check"></span></td>
                        <td className="type"></td>
                        <td className="type"></td>
                        <td className="notes">Work location longitude of this person.</td>
                    </tr>
                    <tr>
                        <td className="attribute">workLocation.countryLabel <span className="fa fa-search entity-search"></span></td>
                        <td className="type"></td>
                        <td className="type"><span className="fa fa-check"></span></td>
                        <td className="type"></td>
                        <td className="type"></td>
                        <td className="notes">Work location country label of this person.</td>
                    </tr>
                    <tr>
                        <td className="attribute">workLocation.countryCode</td>
                        <td className="type"></td>
                        <td className="type"><span className="fa fa-check"></span></td>
                        <td className="type"></td>
                        <td className="type"></td>
                        <td className="notes">Work location two digit country code. Omit if not available.</td>
                    </tr>
                    <tr>
                        <td className="attribute">workLocation.postalCode <span className="fa fa-search entity-search"></span></td>
                        <td className="type"></td>
                        <td className="type"><span className="fa fa-check"></span></td>
                        <td className="type"></td>
                        <td className="type"></td>
                        <td className="notes">Work location postal code of this person.</td>
                    </tr>
                    <tr>
                        <td className="attribute">workLocation.admin1Label <span className="fa fa-search entity-search"></span></td>
                        <td className="type"></td>
                        <td className="type"><span className="fa fa-check"></span></td>
                        <td className="type"></td>
                        <td className="type"></td>
                        <td className="notes">Work location admin1 label of this person.</td>
                    </tr>
                    <tr>
                        <td className="attribute">workLocation.admin1Code <span className="fa fa-search entity-search"></span></td>
                        <td className="type"></td>
                        <td className="type"><span className="fa fa-check"></span></td>
                        <td className="type"></td>
                        <td className="type"></td>
                        <td className="notes">State or Province code (Admin1 GENC code).</td>
                    </tr>
                    <tr>
                        <td className="attribute">workLocation.cityLabel <span className="fa fa-search entity-search"></span></td>
                        <td className="type"></td>
                        <td className="type"><span className="fa fa-check"></span></td>
                        <td className="type"></td>
                        <td className="type"></td>
                        <td className="notes">City.</td>
                    </tr>
                    <tr>
                        <td className="attribute">workLocation.name</td>
                        <td className="type"></td>
                        <td className="type"><span className="fa fa-check"></span></td>
                        <td className="type"></td>
                        <td className="type"></td>
                        <td className="notes">Work location name of this person.</td>
                    </tr>
                    <tr>
                        <td className="attribute">workLocation.streetAddress <span className="fa fa-search entity-search"></span></td>
                        <td className="type"></td>
                        <td className="type"><span className="fa fa-check"></span></td>
                        <td className="type"></td>
                        <td className="type"></td>
                        <td className="notes">Work location street address of this person.</td>
                    </tr>
                    <tr>
                        <td className="attribute">birthLocation.latitude</td>
                        <td className="type"></td>
                        <td className="type"><span className="fa fa-check"></span></td>
                        <td className="type"></td>
                        <td className="type"></td>
                        <td className="notes">Birth location latitude of this person.</td>
                    </tr>
                    <tr>
                        <td className="attribute">birthLocation.longitude</td>
                        <td className="type"></td>
                        <td className="type"><span className="fa fa-check"></span></td>
                        <td className="type"></td>
                        <td className="type"></td>
                        <td className="notes">Birth location longitude of this person.</td>
                    </tr>
                    <tr>
                        <td className="attribute">birthLocation.countryLabel</td>
                        <td className="type"></td>
                        <td className="type"><span className="fa fa-check"></span></td>
                        <td className="type"></td>
                        <td className="type"></td>
                        <td className="notes">Birth location country label of this person.</td>
                    </tr>
                    <tr>
                        <td className="attribute">birthLocation.countryCode</td>
                        <td className="type"></td>
                        <td className="type"><span className="fa fa-check"></span></td>
                        <td className="type"></td>
                        <td className="type"></td>
                        <td className="notes">Birth location two digit country code. Omit if not available.</td>
                    </tr>
                    <tr>
                        <td className="attribute">birthLocation.postalCode</td>
                        <td className="type"></td>
                        <td className="type"><span className="fa fa-check"></span></td>
                        <td className="type"></td>
                        <td className="type"></td>
                        <td className="notes">Birth location postal code of this person.</td>
                    </tr>
                    <tr>
                        <td className="attribute">birthLocation.admin1Label</td>
                        <td className="type"></td>
                        <td className="type"><span className="fa fa-check"></span></td>
                        <td className="type"></td>
                        <td className="type"></td>
                        <td className="notes">Birth location admin1 label of this person.</td>
                    </tr>
                    <tr>
                        <td className="attribute">birthLocation.admin1Code <span className="fa fa-search entity-search"></span></td>
                        <td className="type"></td>
                        <td className="type"><span className="fa fa-check"></span></td>
                        <td className="type"></td>
                        <td className="type"></td>
                        <td className="notes">State or Province code (Admin1 GENC code).</td>
                    </tr>
                    <tr>
                        <td className="attribute">birthLocation.cityLabel <span className="fa fa-search entity-search"></span></td>
                        <td className="type"></td>
                        <td className="type"><span className="fa fa-check"></span></td>
                        <td className="type"></td>
                        <td className="type"></td>
                        <td className="notes">City.</td>
                    </tr>
                    <tr>
                        <td className="attribute">birthLocation.name</td>
                        <td className="type"></td>
                        <td className="type"><span className="fa fa-check"></span></td>
                        <td className="type"></td>
                        <td className="type"></td>
                        <td className="notes">Birth location name of this person.</td>
                    </tr>
                    <tr>
                        <td className="attribute">birthLocation.streetAddress</td>
                        <td className="type"></td>
                        <td className="type"><span className="fa fa-check"></span></td>
                        <td className="type"></td>
                        <td className="type"></td>
                        <td className="notes">Birth location street address of this person.</td>
                    </tr>
                    <tr>
                        <td className="attribute">deathLocation.latitude</td>
                        <td className="type"></td>
                        <td className="type"><span className="fa fa-check"></span></td>
                        <td className="type"></td>
                        <td className="type"></td>
                        <td className="notes">Death location latitude of this person.</td>
                    </tr>
                    <tr>
                        <td className="attribute">deathLocation.longitude</td>
                        <td className="type"></td>
                        <td className="type"><span className="fa fa-check"></span></td>
                        <td className="type"></td>
                        <td className="type"></td>
                        <td className="notes">Death location longitude of this person.</td>
                    </tr>
                    <tr>
                        <td className="attribute">deathLocation.countryLabel</td>
                        <td className="type"></td>
                        <td className="type"><span className="fa fa-check"></span></td>
                        <td className="type"></td>
                        <td className="type"></td>
                        <td className="notes">Death location country label of this person.</td>
                    </tr>
                    <tr>
                        <td className="attribute">deathLocation.countryCode</td>
                        <td className="type"></td>
                        <td className="type"><span className="fa fa-check"></span></td>
                        <td className="type"></td>
                        <td className="type"></td>
                        <td className="notes">Death location two digit country code. Omit if not available.</td>
                    </tr>
                    <tr>
                        <td className="attribute">deathLocation.postalCode</td>
                        <td className="type"></td>
                        <td className="type"><span className="fa fa-check"></span></td>
                        <td className="type"></td>
                        <td className="type"></td>
                        <td className="notes">Death location postal code of this person.</td>
                    </tr>
                    <tr>
                        <td className="attribute">deathLocation.admin1Label</td>
                        <td className="type"></td>
                        <td className="type"><span className="fa fa-check"></span></td>
                        <td className="type"></td>
                        <td className="type"></td>
                        <td className="notes">Death location admin1 label of this person.</td>
                    </tr>
                    <tr>
                        <td className="attribute">deathLocation.admin1Code <span className="fa fa-search entity-search"></span></td>
                        <td className="type"></td>
                        <td className="type"><span className="fa fa-check"></span></td>
                        <td className="type"></td>
                        <td className="type"></td>
                        <td className="notes">State or Province code (Admin1 GENC code).</td>
                    </tr>
                    <tr>
                        <td className="attribute">deathLocation.cityLabel <span className="fa fa-search entity-search"></span></td>
                        <td className="type"></td>
                        <td className="type"><span className="fa fa-check"></span></td>
                        <td className="type"></td>
                        <td className="type"></td>
                        <td className="notes">City.</td>
                    </tr>
                    <tr>
                        <td className="attribute">deathLocation.name</td>
                        <td className="type"></td>
                        <td className="type"><span className="fa fa-check"></span></td>
                        <td className="type"></td>
                        <td className="type"></td>
                        <td className="notes">Death location name of this person.</td>
                    </tr>
                    <tr>
                        <td className="attribute">deathLocation.streetAddress</td>
                        <td className="type"></td>
                        <td className="type"><span className="fa fa-check"></span></td>
                        <td className="type"></td>
                        <td className="type"></td>
                        <td className="notes">Death location street address of this person.</td>
                    </tr>
                    <tr>
                        <td className="attribute">latitude</td>
                        <td className="type"><span className="fa fa-check"></span></td>
                        <td className="type"></td>
                        <td className="type"></td>
                        <td className="type"></td>
                        <td className="notes">The latitude of the geographic location. Omit if not available.</td>
                    </tr>
                    <tr>
                        <td className="attribute">longitude</td>
                        <td className="type"><span className="fa fa-check"></span></td>
                        <td className="type"></td>
                        <td className="type"></td>
                        <td className="type"></td>
                        <td className="notes">The longitude of the geographic location. Omit if not available.</td>
                    </tr>
                    <tr>
                        <td className="attribute">boundingBox.minLatitude</td>
                        <td className="type"><span className="fa fa-check"></span></td>
                        <td className="type"></td>
                        <td className="type"></td>
                        <td className="type"></td>
                        <td className="notes">The geographic location's minimum latitude bounding box. Omit the entire boundBox element if not available.</td>
                    </tr>
                    <tr>
                        <td className="attribute">boundingBox.maxLatitude</td>
                        <td className="type"><span className="fa fa-check"></span></td>
                        <td className="type"></td>
                        <td className="type"></td>
                        <td className="type"></td>
                        <td className="notes">The geographic location's maximum latitude bounding box. Omit the entire boundBox element if not available.</td>
                    </tr>
                    <tr>
                        <td className="attribute">boundingBox.minLongitude</td>
                        <td className="type"><span className="fa fa-check"></span></td>
                        <td className="type"></td>
                        <td className="type"></td>
                        <td className="type"></td>
                        <td className="notes">The geographic location's minimum longitude bounding box. Omit the entire boundBox element if not available.</td>
                    </tr>
                    <tr>
                        <td className="attribute">boundingBox.maxLongitude</td>
                        <td className="type"><span className="fa fa-check"></span></td>
                        <td className="type"></td>
                        <td className="type"></td>
                        <td className="type"></td>
                        <td className="notes">The geographic location's maximum longitude bounding box. Omit the entire boundBox element if not available.</td>
                    </tr>
                    <tr>
                        <td className="attribute">population</td>
                        <td className="type"><span className="fa fa-check"></span></td>
                        <td className="type"></td>
                        <td className="type"></td>
                        <td className="type"></td>
                        <td className="notes">The population of the geographic location. Omit if not available.</td>
                    </tr>
                    <tr>
                        <td className="attribute">dsgFeatureClass</td>
                        <td className="type"><span className="fa fa-check"></span></td>
                        <td className="type"></td>
                        <td className="type"></td>
                        <td className="type"></td>
                        <td className="notes">The <Link to="/dsg_classes">DSG feature class</Link> of the geographic location. Specified as a single capitalized letter. Omit if not available.</td>
                    </tr>
                    <tr>
                        <td className="attribute">dsgFeatureClassLabel</td>
                        <td className="type"><span className="fa fa-check"></span></td>
                        <td className="type"></td>
                        <td className="type"></td>
                        <td className="type"></td>
                        <td className="notes">The DSG feature class label. Omit if not available.</td>
                    </tr>  
                    <tr>
                        <td className="attribute">dsgFeatureCode</td>
                        <td className="type"><span className="fa fa-check"></span></td>
                        <td className="type"></td>
                        <td className="type"></td>
                        <td className="type"></td>
                        <td className="notes">The <Link to="/dsg_codes">DSG feature code</Link> of the geographic location. A two to five-character code used to identify the type of feature a name is applied to. Omit if not available.</td>
                    </tr>    
                    <tr>
                        <td className="attribute">dsgFeatureCodeLabel</td>
                        <td className="type"><span className="fa fa-check"></span></td>
                        <td className="type"></td>
                        <td className="type"></td>
                        <td className="type"></td>
                        <td className="notes">The DSG feature code display name. Omit if not available.</td>
                    </tr> 
                    <tr>
                        <td className="attribute">dsgFeatureCodeDescription</td>
                        <td className="type"><span className="fa fa-check"></span></td>
                        <td className="type"></td>
                        <td className="type"></td>
                        <td className="type"></td>
                        <td className="notes">The DSG feature code description. Omit if not available.</td>
                    </tr>   
                    <tr>
                        <td className="attribute">countryLabel</td>
                        <td className="type"><span className="fa fa-check"></span></td>
                        <td className="type"></td>
                        <td className="type"></td>
                        <td className="type"></td>
                        <td className="notes">The Finch canonical name for the country. Omit if not available.</td>
                    </tr>   
                    <tr>
                        <td className="attribute">countryFips</td>
                        <td className="type"><span className="fa fa-check"></span></td>
                        <td className="type"></td>
                        <td className="type"></td>
                        <td className="type"></td>
                        <td className="notes">The two-character <Link to="/fips_codes">FIPS country code</Link>. Omit if not available.</td>
                    </tr>     
                    <tr>
                        <td className="attribute">countryGenc2</td>
                        <td className="type"><span className="fa fa-check"></span></td>
                        <td className="type"></td>
                        <td className="type"></td>
                        <td className="type"></td>
                        <td className="notes"><Link to="/genc_codes">GENC country digraph</Link> for the location. Omit if not available.</td>
                    </tr>   
                    <tr>
                        <td className="attribute">countryGenc3</td>
                        <td className="type"><span className="fa fa-check"></span></td>
                        <td className="type"></td>
                        <td className="type"></td>
                        <td className="type"></td>
                        <td className="notes"><Link to="/genc_codes">GENC country trigraph</Link> for the location. Omit if not available.</td>
                    </tr>  
                    <tr>
                        <td className="attribute">countryGencCode</td>
                        <td className="type"><span className="fa fa-check"></span></td>
                        <td className="type"></td>
                        <td className="type"></td>
                        <td className="type"></td>
                        <td className="notes"><Link to="/genc_codes">GENC country numeric code</Link> for the location. Omit if not available.</td>
                    </tr>  
                    <tr>
                        <td className="attribute">countryDsgFeatureCode</td>
                        <td className="type"><span className="fa fa-check"></span></td>
                        <td className="type"></td>
                        <td className="type"></td>
                        <td className="type"></td>
                        <td className="notes">The <Link to="/dsg_codes">DSG feature code</Link> of the geographic location's country. A two to five-character code used to identify the type of feature a name is applied to. Omit if not available.</td>
                    </tr>  
                    <tr>
                        <td className="attribute">admin1Label</td>
                        <td className="type"><span className="fa fa-check"></span></td>
                        <td className="type"></td>
                        <td className="type"></td>
                        <td className="type"></td>
                        <td className="notes">The Finch canonical name for the country's first administration level. Omit if not available.</td>
                    </tr>
                    <tr>
                        <td className="attribute">admin1Fips</td>
                        <td className="type"><span className="fa fa-check"></span></td>
                        <td className="type"></td>
                        <td className="type"></td>
                        <td className="type"></td>
                        <td className="notes">The four-character <Link to="/fips_codes">FIPS region code</Link>. Omit if not available.</td>
                    </tr>
                    <tr>
                        <td className="attribute">admin1Genc</td>
                        <td className="type"><span className="fa fa-check"></span></td>
                        <td className="type"></td>
                        <td className="type"></td>
                        <td className="type"></td>
                        <td className="notes"><Link to="/genc_codes">GENC province code</Link> for the location. Omit if not available.</td>
                    </tr>
                    <tr>
                        <td className="attribute">admin1DsgFeatureCode</td>
                        <td className="type"><span className="fa fa-check"></span></td>
                        <td className="type"></td>
                        <td className="type"></td>
                        <td className="type"></td>
                        <td className="notes">The <Link to="/dsg_codes">DSG feature code</Link> of the geographic location's first administration level. A two to five-character code used to identify the type of feature a name is applied to. Omit if not available.</td>
                    </tr>
                    <tr>
                        <td className="attribute">admin2Label</td>
                        <td className="type"><span className="fa fa-check"></span></td>
                        <td className="type"></td>
                        <td className="type"></td>
                        <td className="type"></td>
                        <td className="notes">The Finch canonical name for the country's secondary administration level. Omit if not available.</td>
                    </tr>
                    <tr>
                        <td className="attribute">admin2DsgFeatureCode</td>
                        <td className="type"><span className="fa fa-check"></span></td>
                        <td className="type"></td>
                        <td className="type"></td>
                        <td className="type"></td>
                        <td className="notes">The <Link to="/dsg_codes">DSG feature code</Link> of the geographic location's second administration level. A two to five-character code used to identify the type of feature a name is applied to. Omit if not available.</td>
                    </tr>
                    <tr>
                        <td className="attribute">subType <span className="fa fa-search entity-search"></span></td>
                        <td className="type"></td>
                        <td className="type"></td>
                        <td className="type"><span className="fa fa-check"></span></td>
                        <td className="type"><span className="fa fa-check"></span></td>
                        <td className="notes">The subtype of the entity.<br/>
                            <br/>
                            For THING one of: CHEMICAL, FINANCIAL, LEGAL, MEDICAL, PRODUCT, TECHNOLOGY, FUND, TRUST<br/>
                            <br/>
                            For THING with custom "type" field: a string of uppercase letters and underscores.<br/>
                            <br/>
                            For ORGANIZATION one of: COMPANY, CRIMINAL, EDUCATIONAL, GOVERNMENT, NEWS, PERFORMING, SOCIALMEDIA, SPORTS, TRUST, FUND, COMPANY/TICKER.
                        </td>
                    </tr>
                    <tr>
                        <td className="attribute">productType</td>
                        <td className="type"></td>
                        <td className="type"></td>
                        <td className="type"></td>
                        <td className="type"><span className="fa fa-check"></span></td>
                        <td className="notes">The type of product. One of: AIRCRAFT, AUTOMOBILE, SMARTPHONE, MISSILE, POWERPLANT.<br/>
                        <br/>
                        Only present if thing subType is PRODUCT.</td>
                    </tr>
                    <tr>
                        <td className="attribute">subClasses[]</td>
                        <td className="type"></td>
                        <td className="type"></td>
                        <td className="type"></td>
                        <td className="type"><span className="fa fa-check"></span></td>
                        <td className="notes">An array of sub classes for this entity.</td>
                    </tr>        
                    <tr>
                        <td className="attribute">releaseDate</td>
                        <td className="type"></td>
                        <td className="type"></td>
                        <td className="type"></td>
                        <td className="type"><span className="fa fa-check"></span></td>
                        <td className="notes">A string formatted as an ISO-8601 date that represents when the thing was released.</td>
                    </tr>  
                    <tr>
                        <td className="attribute">discontinuedDate</td>
                        <td className="type"></td>
                        <td className="type"></td>
                        <td className="type"></td>
                        <td className="type"><span className="fa fa-check"></span></td>
                        <td className="notes">A string formatted as an ISO-8601 date that represents when the thing was discontinued.</td>
                    </tr>   
                    <tr>
                        <td className="attribute">follows[] <span className="fa fa-star normalized"></span></td>
                        <td className="type"></td>
                        <td className="type"></td>
                        <td className="type"></td>
                        <td className="type"><span className="fa fa-check"></span></td>
                        <td className="notes">An array of things that precedes this thing.</td>
                    </tr>  
                    <tr>
                        <td className="attribute">followedBy[] <span className="fa fa-star normalized"></span></td>
                        <td className="type"></td>
                        <td className="type"></td>
                        <td className="type"></td>
                        <td className="type"><span className="fa fa-check"></span></td>
                        <td className="notes">An array of things that succeeds this thing.</td>
                    </tr>     
                    <tr>
                        <td className="attribute">uses[] <span className="fa fa-star normalized"></span></td>
                        <td className="type"></td>
                        <td className="type"></td>
                        <td className="type"></td>
                        <td className="type"><span className="fa fa-check"></span></td>
                        <td className="notes">An array of strings that represent uses for the thing.</td>
                    </tr>    
                    <tr>
                        <td className="attribute">brand <span className="fa fa-star normalized"></span></td>
                        <td className="type"></td>
                        <td className="type"></td>
                        <td className="type"></td>
                        <td className="type"><span className="fa fa-check"></span></td>
                        <td className="notes">The brand of the thing. For example, iPhone X is a brand of iPhone.</td>
                    </tr> 
                    <tr>
                        <td className="attribute">series <span className="fa fa-star normalized"></span></td>
                        <td className="type"></td>
                        <td className="type"></td>
                        <td className="type"></td>
                        <td className="type"><span className="fa fa-check"></span></td>
                        <td className="notes">The series the thing is contained within. For example, iPhone X is a series of iPhone.</td>
                    </tr>  
                    <tr>
                        <td className="attribute">chemicalFormula <span className="fa fa-star normalized"></span></td>
                        <td className="type"></td>
                        <td className="type"></td>
                        <td className="type"></td>
                        <td className="type"><span className="fa fa-check"></span></td>
                        <td className="notes">If the thing is of subType CHEMICAL, the chemical formula that represents the chemical.</td>
                    </tr> 
                    <tr>
                        <td className="attribute">casNumber</td>
                        <td className="type"></td>
                        <td className="type"></td>
                        <td className="type"></td>
                        <td className="type"><span className="fa fa-check"></span></td>
                        <td className="notes">If the thing is of subType CHEMICAL, identifier for the chemical compound 
                        per {miscUtils.createExternalLink('http://support.cas.org/','CAS Registry')}.</td>
                    </tr> 
                    <tr>
                        <td className="attribute">countries[]</td>
                        <td className="type"></td>
                        <td className="type"></td>
                        <td className="type"></td>
                        <td className="type"><span className="fa fa-check"></span></td>
                        <td className="notes">An array of countries that represent the sovereign state of the entity.</td>
                    </tr> 
                    <tr>
                        <td className="attribute">manufacturers[] <span className="fa fa-star normalized"></span></td>
                        <td className="type"></td>
                        <td className="type"></td>
                        <td className="type"></td>
                        <td className="type"><span className="fa fa-check"></span></td>
                        <td className="notes">An array of objects that represent a things manufacturer.</td>
                    </tr>
                    <tr>
                        <td className="attribute">manufacturers[].label</td>
                        <td className="type"></td>
                        <td className="type"></td>
                        <td className="type"></td>
                        <td className="type"><span className="fa fa-check"></span></td>
                        <td className="notes">The name of the manufacturer.</td>
                    </tr>
                    <tr>
                        <td className="attribute">manufacturers[].finchId</td>
                        <td className="type"></td>
                        <td className="type"></td>
                        <td className="type"></td>
                        <td className="type"><span className="fa fa-check"></span></td>
                        <td className="notes">The Finch KB id of a manufacturer if it exists.</td>
                    </tr>   
                    <tr>
                        <td className="attribute">manufacturers[].permId</td>
                        <td className="type"></td>
                        <td className="type"></td>
                        <td className="type"></td>
                        <td className="type"><span className="fa fa-check"></span></td>
                        <td className="notes">The Thomson Reuters perm id of a manufacturer if it exists.</td>
                    </tr> 
                    <tr>
                        <td className="attribute">powerPlants[] <span className="fa fa-star normalized"></span></td>
                        <td className="type"></td>
                        <td className="type"></td>
                        <td className="type"></td>
                        <td className="type"><span className="fa fa-check"></span></td>
                        <td className="notes">An array of objects that represent a power plant.</td>
                    </tr>
                    <tr>
                        <td className="attribute">powerPlants[].label</td>
                        <td className="type"></td>
                        <td className="type"></td>
                        <td className="type"></td>
                        <td className="type"><span className="fa fa-check"></span></td>
                        <td className="notes">The name of the power plant.</td>
                    </tr>
                    <tr>
                        <td className="attribute">powerPlants[].finchId</td>
                        <td className="type"></td>
                        <td className="type"></td>
                        <td className="type"></td>
                        <td className="type"><span className="fa fa-check"></span></td>
                        <td className="notes">The Finch KB id of a power plant if it exists.</td>
                    </tr>   
                    <tr>
                        <td className="attribute">powerPlants[].permId</td>
                        <td className="type"></td>
                        <td className="type"></td>
                        <td className="type"></td>
                        <td className="type"><span className="fa fa-check"></span></td>
                        <td className="notes">The Thomson Reuters perm id of a power plant if it exists.</td>
                    </tr> 
                    <tr>
                        <td className="attribute">operators[] <span className="fa fa-star normalized"></span></td>
                        <td className="type"></td>
                        <td className="type"></td>
                        <td className="type"></td>
                        <td className="type"><span className="fa fa-check"></span></td>
                        <td className="notes">An array of objects that represent a things operator.</td>
                    </tr>
                    <tr>
                        <td className="attribute">operators[].label</td>
                        <td className="type"></td>
                        <td className="type"></td>
                        <td className="type"></td>
                        <td className="type"><span className="fa fa-check"></span></td>
                        <td className="notes">The name of the operator.</td>
                    </tr>
                    <tr>
                        <td className="attribute">operators[].finchId</td>
                        <td className="type"></td>
                        <td className="type"></td>
                        <td className="type"></td>
                        <td className="type"><span className="fa fa-check"></span></td>
                        <td className="notes">The Finch KB id of an operator if it exists.</td>
                    </tr>   
                    <tr>
                        <td className="attribute">operators[].permId</td>
                        <td className="type"></td>
                        <td className="type"></td>
                        <td className="type"></td>
                        <td className="type"><span className="fa fa-check"></span></td>
                        <td className="notes">The Thomson Reuters perm id of an operator if it exists.</td>
                    </tr> 
                    <tr>
                        <td className="attribute">designers[] <span className="fa fa-star normalized"></span></td>
                        <td className="type"></td>
                        <td className="type"></td>
                        <td className="type"></td>
                        <td className="type"><span className="fa fa-check"></span></td>
                        <td className="notes">An array of objects that represent a things designer.</td>
                    </tr>
                    <tr>
                        <td className="attribute">designers[].label</td>
                        <td className="type"></td>
                        <td className="type"></td>
                        <td className="type"></td>
                        <td className="type"><span className="fa fa-check"></span></td>
                        <td className="notes">The name of the designer.</td>
                    </tr>
                    <tr>
                        <td className="attribute">designers[].finchId</td>
                        <td className="type"></td>
                        <td className="type"></td>
                        <td className="type"></td>
                        <td className="type"><span className="fa fa-check"></span></td>
                        <td className="notes">The Finch KB id of a designer if it exists.</td>
                    </tr>   
                    <tr>
                        <td className="attribute">designers[].permId</td>
                        <td className="type"></td>
                        <td className="type"></td>
                        <td className="type"></td>
                        <td className="type"><span className="fa fa-check"></span></td>
                        <td className="notes">The Thomson Reuters perm id of a designer if it exists.</td>
                    </tr> 
                    <tr>
                        <td className="attribute">developers[] <span className="fa fa-star normalized"></span></td>
                        <td className="type"></td>
                        <td className="type"></td>
                        <td className="type"></td>
                        <td className="type"><span className="fa fa-check"></span></td>
                        <td className="notes">An array of objects that represent a things developer.</td>
                    </tr>
                    <tr>
                        <td className="attribute">developers[].label</td>
                        <td className="type"></td>
                        <td className="type"></td>
                        <td className="type"></td>
                        <td className="type"><span className="fa fa-check"></span></td>
                        <td className="notes">The name of the developer.</td>
                    </tr>
                    <tr>
                        <td className="attribute">developers[].finchId</td>
                        <td className="type"></td>
                        <td className="type"></td>
                        <td className="type"></td>
                        <td className="type"><span className="fa fa-check"></span></td>
                        <td className="notes">The Finch KB id of a developer if it exists.</td>
                    </tr>   
                    <tr>
                        <td className="attribute">developers[].permId</td>
                        <td className="type"></td>
                        <td className="type"></td>
                        <td className="type"></td>
                        <td className="type"><span className="fa fa-check"></span></td>
                        <td className="notes">The Thomson Reuters perm id of a developer if it exists.</td>
                    </tr>  
                    </tbody>
                </table>
            </div>
        );
    }
}

export default DocKbAttributes;